import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c251892a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "partition" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "wrap" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["onClick"]

import { useGame } from '@/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'Partition',
  setup(__props) {

const gameStore = useGame();
const { characters } = storeToRefs(gameStore);
const { selectCharacter } = gameStore;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('PARTITION__SELECT_TITLE')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(characters), (ch, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: `ch${index}`,
            class: "option",
            onClick: ($event: any) => (_unref(selectCharacter)(ch))
          }, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t(`PARTITION__OPTION_${ch.partition}`)), 1)
          ], 8, _hoisted_6))
        }), 128))
      ])
    ])
  ]))
}
}

})